import { hasOwnProperty, showOverflow, hideOverflow } from 'vessel/utils'
import { visible, addVisible, removeVisible } from './emitter'

const items = {}

function findItem(name, callback) {
  if (hasOwnProperty(items, name)) {
    return callback(items[name])
  }
}

export default (Vue) => {
  return Vue.observable({
    focused: null,
    active: null,
    focus: addVisible,
    unfocus: removeVisible,
    hideOverflow() {
      this.focused = visible[visible.length - 1]
      visible.length == 1 && hideOverflow()
    },
    showOverflow() {
      this.focused = visible[visible.length - 1]
      visible.length == 0 && showOverflow()
    },
    register(name, component) {
      items[name] = component
    },
    unregister(name) {
      items[name] = null
    },
    toggle(name) {
      findItem(name, item => item.toggle())
    },
    open(name) {
      findItem(name, item => item.open())
    },
    close(name) {
      findItem(name, item => item.close())
    },
    isOpened(name) {
      return this.active === name
    },
    isClosed(name) {
      return !this.isOpened(name)
    }
  })
}
